import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { ThemeProvider } from "styled-components"

import componentThemeExtension from "utils/componentThemeExtension"

import Navigation from "components/navigation"

const ContentfulNavigation = (props) => {
  const { contentfulNavigation: defaultNavigation } = useStaticQuery(
    graphql`
      query {
        contentfulNavigation(internalId: { eq: "default-navigation" }) {
          ... on ContentfulNavigation {
            ...navigationFields
          }
        }
      }
    `,
  )
  // use override navigation if provided, otherwise use default one
  const { tabs } = props.component || defaultNavigation

  return (
    <ThemeProvider theme={componentThemeExtension("White")}>
      <Navigation tabs={tabs} {...props} />
    </ThemeProvider>
  )
}

export default ContentfulNavigation
